const resource = 'messageLists'

export default ($axios) => ({
	getMessageLists(params={}) {
		return $axios.get(`/${resource}`, { params } )
	},
	getMySubscriptions(id, voucher) {
		return $axios.get(`/api/${resource}/mySubscriptions/${id}/${voucher}` )
	}
})
